// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { map } from 'rxjs';
import { memo } from '@polkadot/rpc-core';
export function firstObservable(obs) {
  return obs.pipe(map(_ref => {
    let [a] = _ref;
    return a;
  }));
}
export function firstMemo(fn) {
  return (instanceId, api) => memo(instanceId, function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return firstObservable(fn(api, ...args));
  });
}